import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import './stepper-mobile.scss';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { useEffect, useState } from 'react';
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#FFD100' : '#E6E9ED',
    },
}));
const StepperMobile = (props) => {
    const { steps } = props;
    const [progress, setProgress] = useState(0);
    const [lastStepActive, setLastStepActive] = useState(0);
    useEffect(() => {
        const totalSteps = steps.length;
        let stepsActives = 0;
        steps.map((step, index) => {
            if (step.active) {
                stepsActives = stepsActives + 1;
                setLastStepActive(index + 1);
            }
        });
        setProgress((stepsActives / totalSteps) * 100);
    }, []);
    return (_jsxs("div", { className: "stepper-mobile-component", children: [_jsx(BorderLinearProgress, { className: 'stepper-mobile-component_progress-bar', variant: "determinate", value: progress }), _jsxs(Typography, { className: 'stepper-mobile-component_label', children: [lastStepActive, " de ", steps.length] })] }));
};
export default StepperMobile;
